import type { MicroCMSImage } from 'microcms-js-sdk';

/** MicroCMSImage の配列から url の配列を返す */
export const extractImageUrls = (images: MicroCMSImage[]) => {
  return images.map((image) => image.url);
};
